import { render, staticRenderFns } from "./Filtro.vue?vue&type=template&id=afd85952&"
import script from "./Filtro.vue?vue&type=script&lang=ts&"
export * from "./Filtro.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports